import useAlarmsByGroup from '../../../../../../redux/alarm/hooks/useAlarmsByGroup';
import { EntityActionsProps } from './EntityActions';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import { ErrorIcon } from '../../../../../../assets';
import {
  createSearchParams,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { fromBase64 } from '../../../../../../shared/util/base64';

export function EntityAlarmsAction(props: EntityActionsProps) {
  const { entity, active } = props;
  const groupId = fromBase64(entity?.id ?? '');

  const { data: alarmsData, isLoading: isLoadingAlarmsData } = useAlarmsByGroup(
    { groupId }
  );
  const [searchBarParams] = useSearchParams();
  const searchParamsObject = Object.fromEntries(searchBarParams.entries());
  // is actually in a group
  const { groupId: groupIdFromParams } = useParams<'marketId' | 'groupId'>();
  const queryParams = createSearchParams({
    ...searchParamsObject,
    alarmsActive: !active + '',
  }).toString();
  const href = groupIdFromParams
    ? `../${entity?.uuid}?${queryParams}`
    : `./${entity?.uuid}?${queryParams}`;

  if (alarmsData?.length === 0 && !isLoadingAlarmsData) {
    return null;
  }
  if (isLoadingAlarmsData) {
    return (
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'center'}
        margin={'0.5rem'}
      >
        <CircularProgress size={24} />
      </Stack>
    );
  }
  return (
    <Button
      variant={active ? 'contained' : 'outlined'}
      color={active ? 'primary' : 'inherit'}
      loading={isLoadingAlarmsData}
      href={href}
      sx={{
        fontSize: '1rem',
        width: '6rem',
        height: '3rem',
      }}
    >
      <Stack direction={'row'} spacing={0.5}>
        <Typography
          component="span"
          variant={'inherit'}
          color={!active ? 'error' : 'inherit'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <ErrorIcon height={'1.5em'} />
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          fontSize={'1rem'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          |
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          display={'flex'}
          alignItems={'center'}
          fontSize={'1rem'}
          justifyContent={'center'}
        >
          {alarmsData?.length}
        </Typography>
      </Stack>
    </Button>
  );
}
